import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Beranda from "./pages/Beranda";
import NotFound from "./pages/NotFound";
import ListProperti from "./pages/ListProperti";
import DetailProperti from "./pages/DetailProperti";
import Akun from "./pages/Akun";
import Login from "./pages/Login";
import Register from "./pages/Register";
import RentingProperty from "./pages/RentingProperty";
import { ConfigProvider } from "antd";
import "antd/dist/antd.css";

function Root() {
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: "#ff5a3c", // primary color
                },
            }}
        >
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Beranda />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/property-list" element={<ListProperti />} />
                    <Route path="/rent-property/:type/:id" element={<RentingProperty />} />
                    <Route path="/product-details/:type/:id" element={<DetailProperti />} />
                    <Route path="/my-account" element={<Akun />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
        </ConfigProvider>
    );
}

export default Root;

const root = ReactDOM.createRoot(document.getElementById("quarter"));
root.render(<Root />);
